/* Coverly card — swatch swaps the card photo.

   The swatch only becomes a button when the product actually has a photo for
   that colourway (matched on alt text in Liquid), so anything clickable here
   is guaranteed to have somewhere to go. Clicking the active swatch again puts
   the original hero back. */
(function () {
  function cardOf(el) { return el.closest(".ccard"); }

  function restore(card) {
    var img = card.querySelector(".ccard__img");
    if (!img || img.dataset.ccardOriginal == null) return;
    img.onerror = null;
    img.src = img.dataset.ccardOriginal;
    img.srcset = img.dataset.ccardOriginalSrcset || "";
    img.alt = img.dataset.ccardOriginalAlt || "";
  }

  function show(card, button) {
    var img = card.querySelector(".ccard__img");
    var url = button.dataset.photo;
    if (!img || !url) return; // link-only swatch: retargeting already happened

    // Load out of band first. A photo built from the Files naming convention
    // is a guess — Liquid cannot check whether the file exists — so the card
    // keeps showing what it already has until the new image is known good.
    // A colour with no photograph therefore changes nothing at all, rather
    // than flashing a broken image or substituting the flat sample chip.
    var probe = new Image();

    probe.onload = function () {
      // Stashed on first use so the hero is always recoverable.
      if (img.dataset.ccardOriginal == null) {
        img.dataset.ccardOriginal = img.currentSrc || img.src;
        img.dataset.ccardOriginalSrcset = img.getAttribute("srcset") || "";
        img.dataset.ccardOriginalAlt = img.getAttribute("alt") || "";
      }
      // srcset outranks src, so it has to be cleared or the browser keeps
      // picking a candidate from the original set.
      img.srcset = "";
      img.src = url;
      img.alt = button.dataset.colour || img.dataset.ccardOriginalAlt || "";
    };

    probe.onerror = function () {
      // Remembered, so a second click does not re-request a file that is not
      // there, and the swatch stops pretending to be a control.
      button.dataset.photoMissing = "true";
      clear(card);
    };

    probe.src = url;
  }

  /* Point the card at this colour.

     Only when the sample variant carries the configurator's own value for it —
     never a slugified display name. A wrong value would be discarded by the
     configurator on arrival anyway, but a link that silently means nothing is
     worse than a link that plainly does not exist.

     Both the image and the title link move together; landing on a different
     colour than the one just clicked would be its own bug. */
  function retarget(card, value) {
    var root = document.documentElement.dataset;
    var key = root.ccardOptionKey || "color";
    // Match however the configurator is set to read this option. A fragment
    // keeps the parameter off the product URL entirely; a query string is the
    // safe default, because an option set to read the fragment falls back to
    // reading the query string anyway.
    var sep = root.ccardUrlStyle === "hash" ? "#" : "?";
    card.querySelectorAll("[data-ccard-link]").forEach(function (a) {
      var base = a.dataset.ccardHref
        || (a.dataset.ccardHref = a.getAttribute("href").split("?")[0].split("#")[0]);
      if (!value) { a.setAttribute("href", base); return; }
      a.setAttribute("href", base + sep + encodeURIComponent(key) + "=" + encodeURIComponent(value));
    });
  }

  function clear(card) {
    card.querySelectorAll("[data-ccard-swatch]").forEach(function (b) {
      b.setAttribute("aria-pressed", "false");
    });
  }

  document.addEventListener("click", function (e) {
    var button = e.target.closest && e.target.closest("[data-ccard-swatch]");
    if (!button) return;
    var card = cardOf(button);
    if (!card) return;

    // A swatch already known to have no photo does nothing at all — it must
    // not deselect whatever the shopper is currently looking at. A swatch that
    // never had one but does carry a configurator value is a different case:
    // it still retargets the link, it just cannot change the picture.
    if (button.dataset.photoMissing === "true" && !button.dataset.cfgValue) return;

    var wasOn = button.getAttribute("aria-pressed") === "true";
    clear(card);
    if (wasOn) {
      restore(card);
      retarget(card, null);
      return;
    }
    button.setAttribute("aria-pressed", "true");
    retarget(card, button.dataset.cfgValue || null);
    show(card, button);
  });
})();
